import React from "react";
import { createRoot } from "react-dom/client";
import { initWdyr } from "./Utils/wdyr";
import Loading from "UIComponents/Loading/LoadingV3";
import AppBoot from "./boot/AppBoot";
import { applyStoredTheme } from "./Utils/themeUtils";
import "styles/boot.scss";

// Patch React before the first render (dev-only) so wdyr doesn't hit the mounted
// fallback mid-load with a hook-count mismatch. No-op + tree-shaken in prod.
initWdyr();

// Replay the persisted theme before the first paint, otherwise a dark-mode user
// sees a light flash while the lazily-loaded app chunk downloads.
applyStoredTheme();

const root = createRoot(document.getElementById("root"));
root.render(
  <AppBoot
    loadApp={() => import(/* webpackChunkName: "app-main" */ "./main")}
    fallback={<Loading isFullScreen />}
  />
);
